<div class="header">
  <div class="title">
    <div class="title-text">Medical Notes</div>
  </div>
  <span class="message">* populated from PatientNow</span>
</div>
<hr class="divider" />
<fb-simple-table>
  <ng-container fbSimpleTableColumnDef>
    <ng-template fbSimpleTableHeaderCellDef>Date</ng-template>
    <ng-template fbSimpleTableCellDef> <!-- Keep cell empty  --> </ng-template>
  </ng-container>
  <ng-container fbSimpleTableColumnDef>
    <ng-template fbSimpleTableHeaderCellDef>Employee</ng-template>
    <ng-template fbSimpleTableCellDef> <!-- Keep cell empty  --> </ng-template>
  </ng-container>
  <ng-container fbSimpleTableColumnDef>
    <ng-template fbSimpleTableHeaderCellDef>Medical Note</ng-template>
    <ng-template fbSimpleTableCellDef> <!-- Keep cell empty  --> </ng-template>
  </ng-container>
</fb-simple-table>
<hr class="divider" />
<div class="action">
  <rx-icon name="icon-circle-plus-2" class="action-icon" />
  <span class="action-label">Add Medical Note</span>
</div>
